<template>
  <div>
    <header class='demos-header'>
      <h1 class="demos-title">预约登记详情</h1>
    </header>
    <form id="reservationForm" >
      <div id="reservation-row" class="weui-cells weui-cells_form">
        <div class="weui-cell" v-show="roleId !== config.RoleType.SUPPLIER">
          <div class="weui-cell__hd">
            <label class="weui-label" >供应商：</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" :value="respAddParam.supplierName"  style="font-size: 16px;" readonly="readonly">
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" >物料类型：</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" :value="respAddParam.materielType" readonly="readonly">
          </div>
        </div>

        <div class="weui-cell" v-show="respAddParam.businessTypeId === config.BusinessTypeId.waste || respAddParam.businessTypeId === config.BusinessTypeId.veer">
          <div class="weui-cell__hd">
            <label class="weui-label" >操作类型：</label>
          </div>
          <div class="weui-cell__bd">
            <a-select
              v-model="respAddParam.operType"
              style="width: 120px;"
              placeholder="请选择">
            <a-select-option v-for="(item, index) in config.OperTypeList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
          </div>
        </div>

        <div class="weui-cell" v-show="respAddParam.businessTypeId === config.BusinessTypeId.waste || respAddParam.businessTypeId === config.BusinessTypeId.veer">
          <div class="weui-cell__hd">
            <label class="weui-label" >过磅类型：</label>
          </div>
          <div class="weui-cell__bd">
            <a-select
              v-model="respAddParam.weighType"
              style="width: 120px;"
              placeholder="请选择">
            <a-select-option v-for="(item, index) in weighTypeList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
          </div>
        </div>

        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="productName">货物名称：</label>
          </div>
          <div class="weui-cell__bd">
            <span>
                <input v-model="respAddParam.materielName" class="weui-input" style="width:35%" type="text"  readonly="readonly">
            </span>
            <span  v-show="sampling === '1'" >
                <a href="javascript:void(0);" class="weui-btn_mini weui-btn_primary" style="margin-left:0px;color:#fff;border-radius: 10px;font-size:14px" @click="handleEdit">编辑车辆采样信息</a>
            </span>
          </div>    
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="vehicleNo">车牌号：</label>
          </div>
          <div class="weui-cell__bd">
            <a-auto-complete
              v-model="respAddParam.vehicleNo"
              :dataSource="vehicleNoList"
              placeholder=""
              :filterOption="filterOption"
              @blur="(value) => changeVehicleNo(value, true)"
              @change="(value) => changeVehicleNo(value)" 
            />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="driverName">司机姓名：</label>
          </div>
          <div class="weui-cell__bd">
                <a-auto-complete
                v-model="driverShow"
                :dataSource="driverNameList"
                style="width: 170px"
                placeholder=""
                :filterOption="filterOption"
                @change="(value) => changeDriver(value)" 
              />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="phone">手机号：</label>
          </div>
          <div class="weui-cell__bd">
            <a-auto-complete
              v-model="phoneShow"
              :dataSource="phoneList"
              placeholder=""
              :filterOption="filterOption"
              @change="(value) => changePhone(value)" 
              />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label">上门日期：</label>
          </div>
          <div class="weui-cell__bd">
            <a-date-picker  style="width: 100%" placeholder="请选择日期" @change="(dates,dateStr) => changeDate(dates, dateStr)"/>
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" for="idcard">身份证号：</label>
          </div>
          <div class="weui-cell__bd">
            <input v-model="respAddParam.idcard" class="weui-input" type="text" >
          </div>
        </div>

        <div class="weui-cell" v-show="respAddParam.businessTypeId === config.BusinessTypeId.veer">
          <div class="weui-cell__hd">
            <label class="weui-label" >倒入地点：</label>
          </div>
          <div class="weui-cell__bd">
            <a-select
              v-model="respAddParam.getPlace"
              style="width: 120px;"
              placeholder="请选择">
            <a-select-option v-for="(item, index) in placeList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
          </div>
        </div>

        <div class="weui-cell" v-show="respAddParam.businessTypeId === config.BusinessTypeId.veer">
          <div class="weui-cell__hd">
            <label class="weui-label" >倒出地点：</label>
          </div>
          <div class="weui-cell__bd">
            <a-select
              v-model="respAddParam.outPlace"
              style="width: 120px;"
              placeholder="请选择">
            <a-select-option v-for="(item, index) in placeList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
          </div>
        </div>

        <div class="weui-cell">
          <a href="javascript:void(0);" class="weui-btn weui-btn_primary" @click="addReservation">预约提交</a>
        </div>
        
      </div>
    </form>
  
    <div class="weui-cell">
      <div class="weui-cell__bd">
        <a onclick="history.back()" class="weui-btn weui-btn_primary">返回</a>
        <a href="/" class="weui-btn weui-btn_primary">回到首页</a>
      </div>
    </div>

    <a-modal title="操作" 
    style="top: 1px;" 
    :width="400"
    v-model="visible"
    @ok="handleOk"
    >
  
    <a-form class="ant-advanced-search-form" :form="form">
      <a-row :gutter="18">
        <a-col  :span="8" :style="{ display: 'block'}">
          <a-form-item label="车厢长" style="{position:absolute;left:10px;}">
            <a-input-number  v-model="mdl.carriageLength" :min="0" placeholder="" />
          </a-form-item>
        </a-col>
  
        <a-col :span="8" :style="{ display: 'block'}">
          <a-form-item label="车厢宽" style="{position:absolute;left:10px;}">
            <a-input-number v-model="mdl.carriageWidth" :min="0" placeholder="" />
          </a-form-item>
        </a-col>
        <a-col  :span="8" :style="{ display: 'block'}">
          <a-form-item label="车厢高" style="{position:absolute;left:10px;right:10px;}">
            <a-input-number v-model="mdl.carriageHeight" :min="0" placeholder="" />
          </a-form-item>
        </a-col>

        <a-col :span="8" :style="{ display: 'block'}">
          <a-form-item label="采样深度" style="{position:absolute;left:10px;}">
            <a-input-number v-model="mdl.samplingDepth" :min="0" placeholder="" />
          </a-form-item>
        </a-col>
  
        <a-col :span="8" :style="{ display: 'block'}">
          <a-form-item label="弃料深度" style="{position:absolute;left:10px;}">
            <a-input-number v-model="mdl.abandonDepth" :min="0" placeholder="" />
          </a-form-item>
        </a-col>
        <a-col :span="8" :style="{ display: 'block'}">
          <a-form-item label="车底板高" style="{position:absolute;left:10px;}">
            <a-input-number v-model="mdl.baseboardHeight" :min="0" placeholder="" />
          </a-form-item>
        </a-col>

        <a-col :span="8" :style="{ display: 'block'}">
          <a-form-item label="禁采区长度" style="{position:absolute;left:5px;}">
            <a-input-number v-model="mdl.banSamplingLength" :min="0" placeholder="" />
          </a-form-item>
        </a-col>
  
        <a-col :span="8" :style="{ display: 'block'}">
          <a-form-item label="禁采取位置" style="{position:absolute;left:5px;}">
            <a-input-number v-model="mdl.banSamplingPosition" :min="0" placeholder="" />
          </a-form-item>
        </a-col>

        <a-col :span="8" :style="{ display: 'block'}">
          <a-form-item label="加强筋1左位置" style="{position:absolute;left:5px;}">
            <a-input-number v-model="mdl.strengthenRibLeft1" :min="0" placeholder="" />
          </a-form-item>
        </a-col>
  
        <a-col :span="8" :style="{ display: 'block'}">
          <a-form-item label="加强筋2左位置">
            <a-input-number v-model="mdl.strengthenRibLeft2" :min="0" placeholder="" />
          </a-form-item>
        </a-col>
        <a-col :span="8" :style="{ display: 'block'}">
          <a-form-item label="加强筋3左位置">
            <a-input-number v-model="mdl.strengthenRibLeft3" :min="0" placeholder="" />
          </a-form-item>
        </a-col>

        <a-col :span="8" :style="{ display: 'block'}">
          <a-form-item label="加强筋4左位置">
            <a-input-number v-model="mdl.strengthenRibLeft4" :min="0" placeholder="" />
          </a-form-item>
        </a-col>
  
        <a-col :span="8" :style="{ display: 'block'}">
          <a-form-item label="加强筋5左位置">
            <a-input-number v-model="mdl.strengthenRibLeft5" :min="0" placeholder="" />
          </a-form-item>
        </a-col>
        
        <a-col :span="8" :style="{ display: 'block'}">
          <a-form-item label="加强筋1右位置">
            <a-input-number v-model="mdl.strengthenRibRight1" :min="0" placeholder="" />
          </a-form-item>
        </a-col>
  
        <a-col :span="8" :style="{ display: 'block'}">
          <a-form-item label="加强筋2右位置">
            <a-input-number v-model="mdl.strengthenRibRight2" :min="0" placeholder="" />
          </a-form-item>
        </a-col>
        <a-col :span="8" :style="{ display: 'block'}">
          <a-form-item label="加强筋3右位置">
            <a-input-number v-model="mdl.strengthenRibRight3" :min="0" placeholder="" />
          </a-form-item>
        </a-col>

        <a-col :span="8" :style="{ display: 'block'}">
          <a-form-item label="加强筋4右位置">
            <a-input-number v-model="mdl.strengthenRibRight4" :min="0" placeholder="" />
          </a-form-item>
        </a-col>
  
        <a-col :span="8" :style="{ display: 'block'}">
          <a-form-item label="加强筋5右位置">
            <a-input-number v-model="mdl.strengthenRibRight5" :min="0" placeholder="" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" :style="{ textAlign: 'right' }">
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
  </div>
</template>

<script>
  import { reservationAdd, baseInfoList } from '@/api/logistics'
  import { vehicleSamplingSave, vehicleSamplingFindByVehicleNo } from '@/api/basic'
  import storage from "@/utils/storage"
  import { showMsg } from '@/utils/util'
  import Bus from '@/layouts/bus'
  export default {
    name: 'HelloWorld',
    data() {
      return {
        // bizList:this.config.bizList,
        bizList:this.$store.getters.bizList,
        roleId:null,
        corpSupplierId: null,
        respAddParam:{},

        materielList:[],
        driverList:[],
        vehicleList:[],
        vehicleNoList:[],
        driverNameList:[],
        phoneList:[],
        suggestionList:[],

        driverShow: '',
        vehicleShow:'',
        phoneShow:'',

        wasteWeighTypeList:[],
        veerWeighTypeList:[],
        placeList:[],

        weighTypeList:[],
        sampling: '0',

        form: this.$form.createForm(this),
        mdl: {},
        visible: false,

      }
    },
    created () {
      this.roleId = this.$store.getters.roles
      let respAddParamCache = storage.fetch("cache-respAddParam");
      if (respAddParamCache){
        this.respAddParam = JSON.parse(respAddParamCache);
      }
      this.loadBaseInfoList()
    },

    methods: {
      handleEdit () {
        if (!this.respAddParam.vehicleNo) {
          showMsg('请先输入车号',3)
          return
        }
        if (this.respAddParam.vehicleNo.length != 7) {
          showMsg('请输入有效的车号',3)
          return
        }
        this.form = this.$form.createForm(this)
        // 弹出框显示
        this.visible = true
        this.mdl.vehicleNo = this.respAddParam.vehicleNo
        this.mdl.corpSupplierId = this.respAddParam.corpSupplierId

        vehicleSamplingFindByVehicleNo({'vehicleNo':this.respAddParam.vehicleNo})
          .then(res => {
            if (res.code === '0') {
              this.mdl = res.data
            }
          }).catch((e) => {
            console.log(e)
        }).finally((res) => {
          this.confirmLoading = false
        })
      },
      handleOk () {
        if ( this.roleId !== this.config.RoleType.SUPPLIER && !this.respAddParam.corpSupplierId){
          showMsg('请选择供应商',3)
          return;
        }
        this.mdl.corpSupplierId = this.respAddParam.corpSupplierId
        this.confirmLoading = true
        let that = this
        Bus.$emit('showSpinning', true, "提交中...")
        vehicleSamplingSave(Object.assign({}, this.mdl))
          .then(res => {
            if (res.code === '0') {
              showMsg("保存成功",2, function(){
                that.visible = false
                that.$form.createForm(this)
                that.mdl = {}
              })
            }
          }).catch((e) => {
            console.log(e)
        }).finally((res) => {
          that.confirmLoading = false
          Bus.$emit('showSpinning', false)
        })
      },

      // 判断选择的物料是否需要采样
      isRequireSampling(selectMaterielId){
        for (let i = 0; i < this.materielList.length; i++){
          let materiel = this.materielList[i];
          if (selectMaterielId === materiel.id){
              return materiel.sampling
          }
        }
      },
      querySuggetion(driverName, phone){
        for (let i=0; i< this.suggestionList.length;i++){
          let suggestion = this.suggestionList[i]
          if (!suggestion) return
          if (driverName && driverName === suggestion.driverName){
              this.changePhone(suggestion.phone, true)
              return
          }
          if (phone && suggestion.phone === phone){
            this.changeDriver(suggestion.driverName, true)
            return
          }
        }
      },
      changeVehicleNo(value, isUpperCase) {
        // 限制只能输入7位
        if (value.length > 7){
          value = value.substring(0,7)
        }
        // 转换成大写
        if (isUpperCase === true && value.length === 7){
          value = value.toUpperCase();
        }
        this.respAddParam.vehicleNo = value
      },
  
      changeDriver(value, isDisableSuggestion) {
        this.respAddParam.driverName = value
        if (value.indexOf("(") != -1){
          let driverName = value.substring(0,value.indexOf("("))
          this.driverShow = driverName
          if (!isDisableSuggestion){
            this.querySuggetion(value)
          }
        }else{
          this.driverShow = value;
        }
      },

      changePhone(value, isDisableSuggestion) {
        this.phoneShow = value
        this.respAddParam.phone = value
        if (!isDisableSuggestion && this.config.Regex.telephone.test(value)){
          this.querySuggetion(null,value)
        }
      },
      loadBaseInfoList () { 
        new Promise((resolve,reject) => {
          const data = baseInfoList({ }).then(res => { 
            console.log(res)
            return res.data 
          })
          resolve(data)
        }).then(res => {
          this.materielList = res.materielList
          this.driverList = res.driverList
          this.vehicleList = res.vehicleList
          this.vehicleNoList = res.vehicleNoList
          this.driverNameList = res.driverNameList
          this.phoneList = res.phoneList
          this.suggestionList = res.suggestionList

          this.wasteWeighTypeList = res.wasteWeighTypeList
          this.veerWeighTypeList = res.veerWeighTypeList
          
          if (this.respAddParam.businessTypeId === this.config.BusinessTypeId.waste){
            this.weighTypeList = this.wasteWeighTypeList
          }
          if (this.respAddParam.businessTypeId === this.config.BusinessTypeId.veer){
            this.weighTypeList = this.veerWeighTypeList
          }
          this.placeList = res.placeList

          this.sampling = this.isRequireSampling(this.respAddParam.materielId)
  
        }).catch(error => {
          //reject(error)
        })
      },

      filterOption (input, option) { 
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },

      addReservation () { 
        if (!this.validate()){
          return
        }
        const _this = this
        _this.confirmLoading = true
        Bus.$emit('showSpinning', true, "提交中...")
        let respList = []
        respList.push(this.respAddParam)
        reservationAdd(JSON.stringify(respList))
        .then(res => {
          if (res.code === '0') {
            showMsg('提交成功')
            this.$router.push({ name: 'wxRespList' })
          }
        }).catch((e) => {
            console.log(e)
        }).finally(() => {
          _this.confirmLoading = false
          Bus.$emit('showSpinning', false)
        })
      },
      changeDate(dates, dateStrings) {
        this.respAddParam.appointedDate = dateStrings
      },
      validate () {
        if (this.roleId !== this.config.RoleType.SUPPLIER && !this.respAddParam.corpSupplierId){
          showMsg('供应商不能为空')
          return;
        }
        if (!this.respAddParam.businessTypeId){
          showMsg('物料类型不能为空')
          return false
        }
        if (!this.respAddParam.materielId){
          showMsg('物料不能为空')
          return false
        }
        if (!this.respAddParam.vehicleNo || !this.respAddParam.vehicleNo || !this.respAddParam.phone || !this.respAddParam.appointedDate){
          showMsg('请完善预约信息')
          return false
        }
        if (this.respAddParam.vehicleNo.length != 7){
          showMsg('车牌号必须为七位数')
          return false;
        }

        if (!this.config.Regex.telephone.test(this.respAddParam.phone)) {
          showMsg('手机号格式错误')
          return false
        }

        var today = new Date();
        var targetDate = new Date(this.respAddParam.appointedDate+" 23:59:59".replace("-", "/").replace("-", "/"));
        if (targetDate < today){
          showMsg('上门日期不能小于当天')
          return false;
        }
        
        if (this.respAddParam.businessTypeId == this.config.BusinessTypeId.waste || this.respAddParam.businessTypeId == this.config.BusinessTypeId.veer){
          if (!this.respAddParam.operType){
            showMsg('操作类型不能为空',3)
            return false;
          }
          if (!this.respAddParam.weighType){
            showMsg('过磅类型不能为空',3)
            return false;
          }
        }
        return true
      },

      toReservation() {
        this.$router.push({ name: 'wxRespAdd' })
      },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /deep/ .ant-input {
        border:1px;
        font-size: 16px;
        margin-left: -10px;
        height: 1.47058824em;
        line-height: 1.47058824
      }
  /deep/ .ant-select-auto-complete.ant-select .ant-input{
        font-size: 16px;
      }

  /deep/ .ant-select-selection {
    border:0px;
    font-size: 16px;
    margin-left: -10px;
    height: 1.47058824em;
    line-height: 1.47058824
  }

 /deep/ .ant-select-selection__placeholder{
        font-size: 16px;
        color:inherit;
      }
  
</style>